<template>
  <div class="acomodar d-flex flex-column">
    <!-- Botón de regreso -->
    <div class="mb-3 p-3">
      <button class="btn btn-danger" @click="$router.push(`/bienvenido`)">
        <i class="bi bi-skip-backward"></i>
      </button>
    </div>

    <div class="header-titulo">
      <h2>PREGUNTAS DE LAS DIFERENTES CATEGORIAS</h2>
    </div>

    <!-- Tabla arriba -->
    <div class="tabla-contenedor w-100 px-3">
      <h2 class="acomodar2">Listado de Preguntas</h2>
      <div class="tabla-scroll" ref="tablaScroll">
        <table class="table tabla-custom">
          <thead>
            <tr>
              <th style="text-align: center;">Id</th>
              <th style="text-align: center;">Módulo</th>
              <th style="text-align: center;">Categoría</th>
              <th style="text-align: center;">Pregunta</th>
              <th style="text-align: center;">Respuesta</th>
              <th style="min-width: 80px;text-align: center;">Acciones</th>
            </tr>
          </thead>
          <transition-group tag="tbody" name="fade" appear>
            <tr v-for="(item, index) in preguntasPaginadas" :key="index">
              <td style="white-space: pre-wrap;">{{ item.id }}</td>
              <td style="white-space: pre-wrap;">{{ item.idModulo }}</td>
              <td style="white-space: pre-wrap;">{{ item.preCategoria }}</td>
              <td style="white-space: pre-wrap;">{{ item.prePregunta }}</td>
              <td style="white-space: pre-wrap;">{{ item.preRespuesta }}</td>
              <td>
                <button class="btn btn-warning btn-sm me-1" @click="abrirModal(item)">
                  <i class="bi bi-pencil"></i>
                </button>
                <button class="btn btn-danger btn-sm" @click="eliminarPregunta(index + (paginaActual - 1) * filasPorPagina)">
                  <i class="bi bi-trash"></i>
                </button>
              </td>
            </tr>
          </transition-group>
        </table>
      </div>

      <!-- Paginación -->
      <div class="paginacion-container">
        <div class="paginacion-scroll">
          <button
            v-for="n in totalPaginas"
            :key="n"
            class="btn btn-outline-primary btn-sm"
            :class="{ active: n === paginaActual }"
            @click="paginaActual = n"
          >
            {{ n }}
          </button>
        </div>
      </div>
    </div>

    <!-- Formulario abajo -->
    <div class="carta mx-auto mt-5" style="max-width: 600px;">
      <h4 class="text-center">Agregar Nueva Pregunta</h4>
      <form @submit.prevent="guardarPregunta">
        <div class="form-group mb-2">
          <label>Módulo:</label>
          <input v-model="nuevaPregunta.idModulo" class="form-control" required />
        </div>
        <div class="form-group mb-2">
          <label>Categoría:</label>
          <input v-model="nuevaPregunta.preCategoria" class="form-control" required />
        </div>
        <div class="form-group mb-2">
          <label>Pregunta:</label>
          <input v-model="nuevaPregunta.prePregunta" class="form-control" required />
        </div>
        <div class="form-group mb-2">
          <label>Respuesta:</label>
          <textarea v-model="nuevaPregunta.preRespuesta" class="form-control" rows="5" style="resize: none; max-height: 150px;"></textarea>
        </div>
        <div class="d-flex justify-content-center mt-3">
          <button type="submit" class="btn btn-success">
            <i class="bi bi-save me-1"></i> Guardar
          </button>
        </div>
      </form>
    </div>

    <!-- Modal lateral -->
    <transition name="slide-horizontal">
      <div v-if="mostrarModal" class="modal-horizontal">
        <div class="modal-content">
          <h5>Editar Pregunta</h5>
          <div class="form-group mb-2">
            <label>Módulo:</label>
            <input v-model="preguntaEditando.idModulo" class="form-control" />
          </div>
          <div class="form-group mb-2">
            <label>Categoría:</label>
            <input v-model="preguntaEditando.preCategoria" class="form-control" />
          </div>
          <div class="form-group mb-2">
            <label>Pregunta:</label>
            <input v-model="preguntaEditando.prePregunta" class="form-control" />
          </div>
          <div class="form-group mb-2">
            <label>Respuesta:</label>
            <textarea v-model="preguntaEditando.preRespuesta" class="form-control" rows="5" style="resize: none; max-height: 150px;"></textarea>
          </div>
          <div class="modal-actions">
            <button class="btn btn-secondary" @click="cerrarModal">Cancelar</button>
            <button class="btn btn-primary" @click="guardarEdicion">
              <i class="bi bi-save me-1"></i> Guardar
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>


<script>
import Swal from "sweetalert2"; 
export default {
  name: "PreFrecuentes",
  data() {
    return {
      preguntas: [],
      categorias: [],
      nuevaPregunta: {
        idModulo: "",
        preCategoria: "",
        prePregunta: "",
        preRespuesta: ""
      },
      preguntaEditando: null,
      mostrarModal: false,
      paginaActual: 1,
      filasPorPagina: 5,
      spinner: false
    };
  },
  computed: {
    preguntasPaginadas() {
      const inicio = (this.paginaActual - 1) * this.filasPorPagina;
      return this.preguntas.slice(inicio, inicio + this.filasPorPagina);
    },
    totalPaginas() {
      return Math.ceil(this.preguntas.length / this.filasPorPagina);
    }
  },
  mounted() {
    this.cargarPreguntas();
  },
  methods: {
    cargarPreguntas() {
      this.axios.get("Dasboards/PreguntasFrecuentes")
        .then((response) => {
          const datos = response.data;
          this.preguntas = datos.map(item => ({
            id: item.id,
            idModulo: item.idModulo,
            preCategoria: item.preCategoria,
            prePregunta: item.prePregunta,
            preRespuesta: this.parsearRespuesta(item.preRespuesta)
          }));
        })
        .catch((error) => {
          console.error("Error al cargar preguntas frecuentes:", error);
        });
    },
    parsearRespuesta(respuesta) {
      return respuesta.replace(/\\r\\n/g, "\n").replace(/\\n/g, "\n");
    },

    guardarPregunta() {
      const nueva = {
      idModulo: Number(this.nuevaPregunta.idModulo),
      preCategoria: this.nuevaPregunta.preCategoria,
      prePregunta: this.nuevaPregunta.prePregunta,
      preRespuesta: this.nuevaPregunta.preRespuesta
      };

      this.axios.post("Dasboards/RegistrarPregunta", nueva)
        .then((response) => {
          const nuevaConID = {
            ...nueva,
            id: response.data.id, // Asegúrate que el backend retorne el ID
            preRespuesta: this.parsearRespuesta(nueva.preRespuesta)
          };
          this.preguntas.push(nuevaConID);

          this.nuevaPregunta = {
            idModulo: "",
            preCategoria: "",
            prePregunta: "",
            preRespuesta: ""
          };

          Swal.fire({
            position: "top-center",
            icon: "success",
            title: "Pregunta registrada correctamente",
            showConfirmButton: false,
            timer: 2000
          });
          this.cargarPreguntas();
        })
        .catch((error) => {
          console.error("Error al registrar la nueva pregunta:", error);
          alert("No se pudo guardar la pregunta. Verifica los datos o intenta más tarde.");
        });
    },

    eliminarPregunta(index) {
      const pregunta = this.preguntas[index];

      if (!pregunta || !pregunta.id) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se puede eliminar la pregunta porque no tiene ID."
        });
        return;
      }

      Swal.fire({
        title: "¿Estás seguro?",
        text: "Esta acción eliminará la pregunta seleccionada",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar"
      }).then((result) => {
        if (result.isConfirmed) {
          this.spinner = true;

          this.axios.delete("Dasboards/EliminarPregunta", {
            params: { id: pregunta.id }
          })
            .then(() => {
              this.preguntas.splice(index, 1);
              Swal.fire({
                position: "top-center",
                icon: "success",
                title: "Pregunta eliminada correctamente",
                showConfirmButton: false,
                timer: 2000
              });
            })
            .catch((error) => {
              console.error("Error al eliminar la pregunta:", error);
              Swal.fire({
                icon: "error",
                title: "Error",
                text: "No se pudo eliminar la pregunta. Intenta más tarde."
              });
            })
            .finally(() => {
              this.spinner = false;
            });
        }
      });
    },

    abrirModal(item) {
      this.preguntaEditando = { ...item };
      this.mostrarModal = true;
    },
    cerrarModal() {
      this.mostrarModal = false;
    },

    guardarEdicion() {
      const datosEditados = {
        id: this.preguntaEditando.id,
        idModulo: Number(this.preguntaEditando.idModulo),
        preCategoria: this.preguntaEditando.preCategoria,
        prePregunta: this.preguntaEditando.prePregunta,
        preRespuesta: this.preguntaEditando.preRespuesta
      };

      this.axios.put("Dasboards/EditarPregunta", datosEditados)
        .then(() => {
          const index = this.preguntas.findIndex(p => p.id === datosEditados.id);
          if (index !== -1) {
            this.$set(this.preguntas, index, {
              ...datosEditados,
              preRespuesta: this.parsearRespuesta(datosEditados.preRespuesta)
            });
          }

          this.cerrarModal();

          Swal.fire({
            icon: "success",
            title: "¡Pregunta editada correctamente!",
            showConfirmButton: false,
            timer: 2000
          });
          this.cargarPreguntas();
        })
        .catch((error) => {
          console.error("Error al editar la pregunta:", error);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "No se pudo editar la pregunta. Intenta más tarde."
          });
        });
    }
  }
};
</script>


<style scoped>
.acomodar {
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  margin-top: 1%;
  margin-bottom: 1%;
  width: 100%;
  background: rgb(255, 255, 255);
  margin-left:1%;
  margin-right: 1%;
  height: auto;
  padding-bottom: 20px;
  border-radius: 10px 10px 10px 10px;
  overflow-x: hidden;
  overflow-y: none;
}

.acomodar2 {
  text-align: center;
  font-family: "Arial Black", sans-serif;
  font-weight: bold;
  margin-bottom: 15px;
  color: #333;
}

.tabla-contenedor {
  flex: 1;
  max-width: 100%;
}

.tabla-scroll {
  overflow-x: auto;
  white-space: nowrap;
  scroll-behavior: smooth;
  border-radius: 10px;
}

.tabla-custom {
  width: 100%;
  border-collapse: collapse;
}

.tabla-custom thead tr {
  background-color: #007bff;
  color: white;
}

.tabla-custom th,
.tabla-custom td {
  padding: 10px;
  border: 1px solid #dee2e6;
  text-align: left;
  vertical-align: top;
}

.tabla-custom tbody tr {
  background-color: white;
  color: black;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateX(20px);
}

.paginacion-container {
  overflow-x: auto;
  padding-top: 10px;
}
.paginacion-scroll {
  display: flex;
  gap: 5px;
  width: max-content;
  padding-bottom: 10px;
}

.modal-horizontal {
  position: fixed;
  right: 0;
  top: 0;
  height: 100%;
  width: 400px;
  background: white;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.3);
  padding: 20px;
  z-index: 1050;
}

.slide-horizontal-enter-active,
.slide-horizontal-leave-active {
  transition: transform 0.3s ease;
}
.slide-horizontal-enter-from,
.slide-horizontal-leave-to {
  transform: translateX(100%);
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 15px;
}

.carta {
  border: 1px solid black;
  padding: 15px;
  border-radius: 15px;
  margin-top: 70px;
}
.header-titulo h2 {
  margin: 0;
  font-weight: bold;
  font-size: 22px;
}
.header-titulo {
  border: 1px solid #ccc;
  padding: 10px 20px;
  margin: 20px;
  text-align: left;
}

</style>
